import { filterFactory } from 'src/app/utils/filter/filter.factory';

/**
 * Filters user objects based on a search term.
 * If the value is an object with 'firstname' and 'lastname' properties,
 * it concatenates them and checks if the concatenated string includes the filter term.
 * Otherwise, it converts the value to a string and checks if it includes the filter term.
 *
 * @param {any} value - The value to be filtered.
 * @param {string} filter - The search term to filter by.
 * @returns {boolean} - True if the value matches the filter, false otherwise.
 */
export const userFilter = filterFactory((value, filter) => {
  // Check if the value is an object with 'firstname' and 'lastname' properties
  if (
    value &&
    typeof value === 'object' &&
    'firstname' in value &&
    'lastname' in value
  ) {
    // Concatenate 'firstname' and 'lastname' and check if it includes the filter term
    return `${value.firstname} ${value.lastname}`.includes(filter);
  }

  // Convert the value to a string and check if it includes the filter term
  return String(value).includes(filter);
});
